import {
    DefinitionListHorizontal,
    DefinitionListItem,
    IconList,
    IconListItem,
    Notification,
    NotificationStatus,
} from '@cp-shared-19/frontend-ui';
import { Button, ButtonContainer, Heading, Layout } from '@vwfs-bronson/bronson-react';
import { dashboardPagePath, withBrandPrefix } from 'components/navigation/paths';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

type SubrogationInfoProps = {
    documentsList: IconListItem[];
    type: string;
    isLegalPerson?: boolean;
    isPrivatePerson?: boolean;
};

export const SubrogationInfo: React.FC<SubrogationInfoProps> = ({
    documentsList,
    type,
    isLegalPerson = false,
    isPrivatePerson = false,
}) => {
    const { t } = useTranslation('request-subrogation');
    const history = useHistory();

    const itemList: DefinitionListItem[] = [
        {
            label: t('subrogation-info.type.label'),
            value: type,
        },
        {
            label: t('subrogation-info.email.label'),
            value: t('subrogation-info.email.value'),
        },
    ];

    let pdfDocument = withBrandPrefix('/pdf-documents/Legal_person_GDPR_2025.pdf');
    if (!isLegalPerson && isPrivatePerson) {
        pdfDocument = withBrandPrefix('/pdf-documents/Natural_person_GDPR_2025.pdf');
    }

    const handleOpenPdfDocument = (): void => {
        window.open(pdfDocument);
    };

    return (
        <>
            <DefinitionListHorizontal list={itemList} />
            <Heading level={3} className="u-mt">
                {t('subrogation-info.title')}
            </Heading>
            <Notification status={NotificationStatus.warning} className={'u-mb'}>
                {t('subrogation-info.notification')}
            </Notification>
            <IconList items={documentsList} />
            {isLegalPerson && (
                <ul>
                    <ul>
                        <li>{t('documents.legal-person.doc13')}</li>
                        <li>{t('documents.legal-person.doc14')}</li>
                        <li>{t('documents.legal-person.doc15')}</li>
                        <li>{t('documents.legal-person.doc16')}</li>
                        <li>{t('documents.legal-person.doc17')}</li>
                    </ul>
                </ul>
            )}
            {(isLegalPerson || isPrivatePerson) && (
                <Layout right>
                    <Layout.Item default="1/2">
                        <ButtonContainer right>
                            <Button
                                element="a"
                                link
                                onClick={e => {
                                    e.preventDefault();
                                    handleOpenPdfDocument();
                                }}
                                testId="pdfDocumentButton"
                                icon="semantic-download"
                                href="/open-pdf"
                            >
                                {t('buttons.download-gdpr-button')}
                            </Button>
                        </ButtonContainer>
                    </Layout.Item>
                </Layout>
            )}
            <ButtonContainer center className="u-mt-large">
                <Button secondary onClick={() => history.push(dashboardPagePath())} testId="backButton" type="button">
                    {t('subrogation-info.back-button')}
                </Button>
            </ButtonContainer>
        </>
    );
};
